import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLoadingState from './loading-flow.reducer';

export const selectLoadingState = createFeatureSelector<fromLoadingState.LoadingFlowState>('loadingState');

export const selectCurrentLoadingState = createSelector(
  selectLoadingState,
  (state) => state
);
